import { inject, observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import shine from "./img/shine.gif";
import "./style.scss";
import { CATEGORY_TIMING, TITLE_STEP_DELAY_MS } from "../timings";
import { delay, sendMetric, getWhatId } from "@utils";
const { VITE_WHAT_ID } = import.meta.env;

const itemsPerRow = 4;

const Category = inject("mainStore")(
    observer(({ mainStore, setIsFortune, timings, isFortune }) => {
        const init = mainStore.getMainStore("init");
        const settingLego = mainStore.getMainStore("settingLego");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");

        const [activeIndices, setActiveIndices] = useState([]);
        const [titleExit, setTitleExit] = useState(false);
        const switchTimerRef = useRef(null);
        const categoryTiming = timings?.category || CATEGORY_TIMING;
        const titleStepDelayMs = timings?.titleStepDelayMs ?? TITLE_STEP_DELAY_MS;
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        const [visibleItems, setVisibleItems] = useState([]);

        const itemRefs = useRef([]);

        const setItemRef = (idx) => (el) => {
            if (el) {
                el.dataset.idx = idx;
                itemRefs.current[idx] = el;
            }
        };

        const visibleRef = useRef([]);

        useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            setVisibleItems((prev) => {
                                const next = new Set(prev);
                                const idx = Number(entry.target.dataset.idx);
                                next.add(idx);
                                return Array.from(next).sort((a, b) => a - b);
                            });
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: "0px",
                    threshold: 1,
                },
            );
            delay(categoryTiming.activeDelayMs).then(() => {
                itemRefs.current.forEach((el) => el && observer.observe(el));
            });

            return () => {
                observer.disconnect();
            };
        }, [categoryTiming.activeDelayMs]);

        useEffect(() => {
            const startTimer = setTimeout(() => {
                switchTimerRef.current = setInterval(() => {
                    setActiveIndices((prev) => {
                        if (prev.length >= categoryTiming.maxActiveItems) {
                            setTitleExit(true);
                            return prev;
                        }

                        const pool = visibleRef.current;
                        if (!pool || pool.length === 0) return prev;

                        if (pool.length === 1) {
                            setTitleExit(true);
                            return [0];
                        }

                        const available = pool.filter((i) => !prev.includes(i));
                        if (available.length === 0) {
                            setTitleExit(true);
                            return prev;
                        }

                        const next = available[Math.floor(Math.random() * available.length)];
                        const nextIndices = [...prev, next];

                        if (nextIndices.length >= categoryTiming.maxActiveItems) {
                            setTimeout(() => setTitleExit(true), categoryTiming.titleExitMs);
                        }

                        return nextIndices;
                    });
                }, categoryTiming.activeSwitchMs);
            }, categoryTiming.activeDelayMs);

            return () => {
                clearTimeout(startTimer);
                clearInterval(switchTimerRef.current);
            };
        }, [categoryTiming.activeDelayMs, categoryTiming.activeSwitchMs, categoryTiming.maxActiveItems, categoryTiming.titleExitMs]);

        useEffect(() => {
            if (!titleExit) {
                return;
            }
            clearInterval(switchTimerRef.current);

            setTimeout(() => {
                sendMetric(`widget_step_1_show`, {
                    params1: [`${"ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: null,
                    params8: what_id,
                });
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_1_show",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }

                mainStore.setMainStore("isVisible", true);
                setIsFortune(true);
            }, categoryTiming.toFortuneMs);
            return;
        }, [titleExit, categoryTiming.toFortuneMs, mainStore, setIsFortune]);

        useEffect(() => {
            visibleRef.current = visibleItems;
        }, [visibleItems]);

        const isPartnerHeaderVariant = settingLego.isPartnerHeaderVariant;

        const titleWords = (isPartnerHeaderVariant && init?.data?._p_n ? `${init.data._p_n} анализирует ваши интересы` : "Анализируем ваши интересы").split(" ");

        return (
            <div className="ai-category">
                <img src={shine} className="ai-category__shine" />

                <div className="ai-category__title">
                    {titleWords.map((word, idx) => {
                        const fromEnd = titleWords.length - 1 - idx;
                        const isPartner = isPartnerHeaderVariant && idx === 0;
                        return (
                            <span key={`${word}-${idx}`} className={`ai-category__title-word ${titleExit ? "is-exit" : "is-enter"} `} style={{ "--delay": `${fromEnd * titleStepDelayMs}ms` }}>
                                {word}
                            </span>
                        );
                    })}
                </div>
                <div className={`ai-category__track ${titleExit ? "is-exit" : ""}`}>
                    {Array.from({ length: Math.ceil(mockCategories.length / itemsPerRow) }, (_, rowIdx) => {
                        const start = rowIdx * itemsPerRow;
                        const end = start + itemsPerRow;
                        const delayClass = rowIdx === 0 ? "" : ` ai-category__items-${rowIdx}`;

                        return (
                            <div key={`row-${rowIdx}`} className={`ai-category__items${delayClass}`}>
                                {mockCategories.slice(start, end).map((item, idx) => {
                                    const itemIndex = start + idx;
                                    const isActive = activeIndices.includes(itemIndex);

                                    return (
                                        <div key={`${item}-${idx}`} className={`ai-category__item${isActive ? " active" : ""}`} ref={setItemRef(itemIndex)}>
                                            {item}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }),
);

export default Category;

const mockCategories = [
    "🍿 Кино и сериалы",
    "💄 Красота",
    "📘 Книги",
    "💍 Украшение",
    "🎉 Развлечения",
    "💳 Финансовые услуги",
    "📘 Книги",
    "📱 Бытовая техника и электроника",
    "⚽ Товары для спорта",
    "🎵 Музыка",
    "✈️ Путешествия",
    "🧶 Товары для дома",
    "🎮 Онлайн-игры",
    "🛍️ Одежда и обувь",
    "✨️ Здоровье и медицина",
    "💻 Интернет-сервисы",
    "🧑🏻‍🏫 Онлайн-образование",
    "🎲  Лотереи и букмекеры",
    "🍎 Супермаркет",
];
